export default "__VITE_ASSET__Bg2BorGe__"